/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const FR2052AReportConfigDetails = ({
    selectedFR2052AQuarter, setSelectedFR2052AQuarter, summaryQuartersFR2052AData, commonFR2052AData,
}) => (
    <ReportConfigDetails
        selectedQuarter={selectedFR2052AQuarter}
        setSelectedQuarter={setSelectedFR2052AQuarter}
        summaryQuartersData={summaryQuartersFR2052AData}
        commonData={commonFR2052AData}
        displayColumn="Yes"
        istopier="No"
        rule="FR2052A"
    />
);

export default FR2052AReportConfigDetails;
